<template>
    <div class="right-contx bgcolor-f6f5fa pull-right">
        <div class="top-titx font-16">
            我的培训
        </div>
        <div class="layui-col-md12 class-container">

            <el-tabs v-model="activeName" type="card" @tab-click="handleClick">
                <el-tab-pane label="职业/项目课" name="first">

                    <div v-if="majorFlaf"
                        style="line-height: 450px;color: lightgray;text-align: center;font-size: 16px;">暂无课程</div>
                    <div class="layui-tab-content" style="padding-left: 0px;padding-right: 0px;">
                        <div v-for="(item,index) in marjorCourseList" :key="index" class="layui-tab-item layui-show">
                            <div id="search_contx" class="search-contx md2018040802-xxw clearfix">
                                <div class="search-contx md2018040802-xxw clearfix workType-container">
                                    <div class="md-19052302-x clearfix md20061001"><a
                                            href="/el/cd?courseId=369&amp;classId=5639">
                                            <div class="left pull-left  no-full-time public-course"><img
                                                    src="../../../../static/img/default-class.jpg" class="left pull-left">
                                            </div>
                                        </a>
                                        <div class="right pull-left public-course-content"><a href="###">
                                                <p class="font-16 color-333 text-overflow tttittt">{{item.courseName}}
                                                </p>
                                            </a>
                                            <div class="color-999 pppp pppp1 p2 clearfix">
                                                <p class="pull-left">课时：<span
                                                        class="color-666">{{item.coursePeriod}}</span></p>
                                            </div>
                                            <div class="color-999 pppp p2 clearfix">
                                                <p class="pull-left">开始时间：<span
                                                        class="color-666">{{item.beginTime}}</span></p>
                                                <p class="pull-left">截止时间：<span class="color-666"
                                                        style="color:red;">{{item.endTime}}</span></p>
                                                <p class="pull-left">剩余时长：<span
                                                        class="color-666">{{item.residueTime}}天</span></p>
                                            </div>
                                            <div class="p5 clearfix" style="width: 100%;"><span
                                                    class="color-999">学习进度:</span>
                                                <v-progress-line :percent="item.courseProgress" status="active"
                                                    style="width: 70%;line-height: 15px;">
                                                </v-progress-line>
                                            </div>
                                            <p class="p4"><a class="btn-0523x bg-4b94ff js-gostudy2"
                                                    @click="beginStudy(item)">开始学习</a></p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                </el-tab-pane>

                <el-tab-pane label="公共课" name="second">
                    <div v-if="publicFlag"
                        style="line-height: 450px;color: lightgray;text-align: center;font-size: 16px;">暂无课程</div>
                    <div class="layui-tab-content" style="padding-left: 0px;padding-right: 0px;">
                        <div v-for="(item,index) in publicCourseList" :key="index" class="layui-tab-item layui-show">
                            <div id="search_contx" class="search-contx md2018040802-xxw clearfix">
                                <div class="search-contx md2018040802-xxw clearfix workType-container">
                                    <div class="md-19052302-x clearfix md20061001"><a
                                            href="/el/cd?courseId=369&amp;classId=5639">
                                            <div class="left pull-left  no-full-time public-course"><img
                                                    src="../../../../static/img/default-class.jpg" class="left pull-left">
                                            </div>
                                        </a>
                                        <div class="right pull-left public-course-content"><a href="###">
                                                <p class="font-16 color-333 text-overflow tttittt">{{item.courseName}}
                                                </p>
                                            </a>
                                            <div class="color-999 pppp pppp1 p2 clearfix">
                                                <p class="pull-left">课时：<span
                                                        class="color-666">{{item.coursePeriod}}</span></p>
                                            </div>
                                            <div class="color-999 pppp p2 clearfix">
                                                <p class="pull-left">开始时间：<span
                                                        class="color-666">{{item.beginTime}}</span></p>
                                                <p class="pull-left">截止时间：<span class="color-666"
                                                        style="color:red;">{{item.endTime}}</span></p>
                                                <p class="pull-left">剩余时长：<span
                                                        class="color-666">{{item.residueTime}}天</span></p>
                                            </div>
                                            <div class="p5 clearfix" style="width: 100%;"><span
                                                    class="color-999">学习进度:</span>
                                                <v-progress-line :percent="item.courseProgress" status="active"
                                                    style="width: 70%;line-height: 15px;">
                                                </v-progress-line>
                                            </div>
                                            <p class="p4"><a class="btn-0523x bg-4b94ff js-gostudy2"
                                                    @click="beginStudy(item)">开始学习</a></p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                </el-tab-pane>
            </el-tabs>
        </div>
    </div>

</template>

<script>
    export default {
        name: 'app',
        components: {

        },
        data() {
            return {
                activeName: 'first',
                flag: false,
                publicCourseList: [],
                marjorCourseList: [],
                publicFlag: false,
                majorFlaf: false
            }
        },
        created() {
            //检查 个人中心培训计划
            this.loadData(this.$route.params.classId, 2);
        },
        mounted() {

        },
        beforeDestroy() {

        },
        methods: {
            beginStudy(item) {

                this.$router.push({ path: '/courseDetail/' + item.courseId + "/" + item.classId + "/" + item.workTypeId + "/" + item.classType });

            },
            handleClick(tab, event) {
                let courseType = 0;

                if (tab.name === 'first') {
                    //职业技能课
                    if(this.$storage.get("declareUser").isExpert == 1){
                        courseType = 4;
                    }else{
                        courseType = 2;
                    }
                   

                } else {
                    //公共课
                    courseType = 1;
                }
                console.log();
                this.loadData(this.$route.params.classId, courseType);
            },
            loadData(classId, courseType) {
                let parames = new URLSearchParams();
                parames.append('userId', this.$storage.get("declareUser").id);
                parames.append('courseType', courseType);
                parames.append('classId', classId);

                this.$axios.post(this.serverUrl + '/class/getUserClassCourse', parames).then(resp => {

                    if (resp.data.code === 1) {
                        if (resp.data.data.length > 0) {
                            let ArrayList = [];
                            for (let i = 0; i < resp.data.data.length; i++) {
                                let CourseEnter = resp.data.data[i]
                                let CourseGo = {
                                    courseId: 0,
                                    courseName: '',//课程名称
                                    coursePeriod: 0,
                                    beginTime: '', //开始时间
                                    endTime: '',//结束时间
                                    classId: 0,
                                    workTypeId: 0,
                                    residueTime: 0,//剩余时间
                                    courseProgress: 0,//课程学习进度
                                    imageUrl: '', //课程图片
                                    classType:0
                                }

                                CourseGo.courseId = CourseEnter.courseId;
                                CourseGo.coursePeriod = CourseEnter.coursePeriod;
                                CourseGo.classId = CourseEnter.classId;
                                CourseGo.workTypeId = CourseEnter.workTypeId;
                                CourseGo.courseName = CourseEnter.courseName;
                                // 添加 null 检查，避免对 null 值调用 substring 方法
                                CourseGo.beginTime = CourseEnter.classBeginTime ? CourseEnter.classBeginTime.substring(0, 10) : CourseEnter.beginTime || '';
                                CourseGo.endTime = CourseEnter.classEndTime ? CourseEnter.classEndTime.substring(0, 10) : CourseEnter.endTime || '';

                                CourseGo.classType = CourseEnter.classType;

                                // 只有当 endTime 有效时才计算剩余时间
                                CourseGo.residueTime = CourseGo.endTime ? ((new Date(CourseGo.endTime).getTime() - new Date().getTime()) / (1000 * 60 * 60 * 24)).toFixed(1) : 0
                                if (CourseEnter.courseProgress != null) {
                                    CourseGo.courseProgress = CourseEnter.courseProgress;
                                } else {
                                    CourseGo.courseProgress = 0;
                                }

                                ArrayList.push(CourseGo);
                            }
                            if (this.activeName === 'first') {
                                this.marjorCourseList = ArrayList;
                            } else {
                                this.publicCourseList = ArrayList;
                            }
                        } else {

                            if (this.activeName === 'first') {
                                this.majorFlaf = true;
                            } else {
                                this.publicFlag = true;
                            }

                        }

                    } else {
                        if (this.activeName === 'first') {
                            this.majorFlaf = true;
                        } else {
                            this.publicFlag = true;
                        }
                    }
                }).catch(err => {

                    this.$message({
                        showClose: true,
                        message: '服务器繁忙，稍后重试！',
                        type: 'error'
                    });
                })
            }


        }
    }
</script>

<style scoped>
    .btn-0523x {
        width: 165px;
        height: 46px;
        line-height: 45px;
        text-align: center;
        color: #fff;
        font-size: 14px;
        border-radius: 6px;
        display: inline-block;
    }

    .bg-4b94ff {
        background: #4b94ff;
    }

    .md20061001 .btn-0523x {
        width: 88px;
        height: 36px;
        line-height: 36px;
    }

    .md-19052302-x .right .p4 {
        position: absolute;
        bottom: 0;
    }

    .md-19052302-x.md20061001 .right .p4 {
        top: 92px !important;
    }

    .md-19052302-x.md20061001 .right .p4 {
        right: 0;
        top: 65px;
        left: auto;
        bottom: auto;
    }

    .clearfix:after {
        clear: both;
        content: ".";
        display: block;
        font-size: 0;
        height: 0;
        line-height: 0;
        visibility: hidden;
    }

    .jindu200610>div span {
        right: -33px !important;
    }

    .jindu200610>div span {
        position: absolute;
        top: -18px;
        color: #666;
        width: 50px;
        right: -25px;
        text-align: center;
    }

    .jindu200610>div {
        position: absolute;
        height: 100%;
        border-radius: 6px;
        background: #2b83f3;
    }

    .jindu200610 {
        margin-left: 15px !important;
    }

    .jindu200610 {
        width: 400px;
        position: relative;
        border-radius: 6px;
        height: 6px;
        background-color: #ddd;
        margin-left: 30px;
    }

    .md20061001 .p5 {
        position: absolute;
        bottom: 10px;
        display: flex;
        align-items: center;
    }

    .md20061001 .pppp p {
        width: 180px;
        margin-right: 20px;
    }

    .color-666 {
        color: #666;
    }

    .cusfont-riqi:before {
        content: "\e623";
    }

    .md20061001 .pppp .cusfont {
        margin-right: 8px;
    }

    .md20061001 .pppp p {
        width: 180px;
        margin-right: 20px;
    }

    .color-999 {
        color: #999;
    }

    .md-19052302-x .right .p2 {
        line-height: 30px;
    }

    .clearfix:after {
        clear: both;
        content: ".";
        display: block;
        font-size: 0;
        height: 0;
        line-height: 0;
        visibility: hidden;
    }

    .color-666 {
        color: #666;
    }

    .cusfont-luxiangji:before {
        content: "\e684";
    }

    .cusfont {
        font-family: "cusfont" !important;
        font-size: 16px;
        font-style: normal;
        -webkit-font-smoothing: antialiased;
        -moz-osx-font-smoothing: grayscale;
    }

    .md20061001 .pppp .cusfont {
        margin-right: 8px;
    }

    .md20061001 .pppp p {
        width: 180px;
        margin-right: 20px;
    }

    .color-999 {
        color: #999;
    }

    .md20061001 .pppp1 {
        margin-top: 0 !important;
    }

    .md-19052302-x .right .p2 {
        line-height: 30px;
    }

    .color-333 {
        color: #333;
    }

    .font-16 {
        font-size: 16px;
    }

    .text-overflow {
        width: 100%;
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
    }

    .tttittt {
        width: 360px;
    }

    .public-course-content {
        margin-left: 30px !important;
        width: 575px !important;
    }

    .md-19052302-x .right {
        position: relative;
        margin-left: 30px;
        height: 153px;
        width: 575px;
    }

    .md-19052302-x .right {
        padding-top: 3px !important;
    }

    .md-19052302-x .left {
        position: relative;
        width: 272px;
        height: 153px;
        border-radius: 6px;
        overflow: hidden;
    }

    .md-19052302-x .left>img {
        display: block;
        width: 100%;
    }

    .pull-left {
        float: left;
    }

    .md-19052302-x .left {
        position: relative;
        width: 272px;
        height: 153px;
        border-radius: 6px;
        overflow: hidden;
    }

    .md-19052302-x {
        border-bottom: 1px solid #ddd;
        padding-bottom: 25px;
        margin-bottom: 25px;
        position: relative;
    }

    .layui-show {
        display: block !important;
    }

    .layui-tab-item {
        display: none;
    }

    .layui-tab-content {
        padding: 10px;
    }

    div /deep/.el-tabs--card>.el-tabs__header .el-tabs__item:first-child {
        border-left: none;
        width: 50%;
        text-align: center;
    }

    div /deep/ .el-tabs--top.el-tabs--card>.el-tabs__header .el-tabs__item:last-child {
        padding-right: 20px;
        width: 50%;
        text-align: center;
    }

    div /deep/ .el-tabs--card>.el-tabs__header .el-tabs__nav {
        border: 1px solid #E4E7ED;
        border-bottom: none;
        border-radius: 4px 4px 0 0;
        -webkit-box-sizing: border-box;
        box-sizing: border-box;
        width: 100%;
    }

    div /deep/ .el-tabs--card>.el-tabs__header .el-tabs__item.is-active {
        border-bottom-color: #FFF;
        width: 50%;
        text-align: center;
    }

    .container:after {
        clear: both;
        content: ".";
        display: block;
        font-size: 0;
        height: 0;
        line-height: 0;
        visibility: hidden;
    }

    .clearfix:after {
        clear: both;
        content: ".";
        display: block;
        font-size: 0;
        height: 0;
        line-height: 0;
        visibility: hidden;
    }

    .color-666 {
        color: #666;
    }

    .cusfont {
        font-family: "cusfont" !important;
        font-size: 16px;
        font-style: normal;
        -webkit-font-smoothing: antialiased;
        -moz-osx-font-smoothing: grayscale;
    }

    .jindu200610>div {
        position: absolute;
        height: 100%;
        border-radius: 6px;
        background: #2b83f3;
    }

    .jindu200610 {
        display: inline-block;
        width: 375px;
        margin-left: 0px !important;
    }

    .jindu200610 {
        width: 400px;
        position: relative;
        border-radius: 6px;
        height: 6px;
        background-color: #ddd;
        margin-left: 30px;
    }

    .layui-btn,
    .layui-input,
    .layui-select,
    .layui-textarea,
    .layui-upload-button {
        outline: 0;
        -webkit-appearance: none;
        transition: all .3s;
        -webkit-transition: all .3s;
        box-sizing: border-box;
    }

    .layui-btn {
        display: inline-block;
        height: 38px;
        line-height: 38px;
        padding: 0 18px;
        background-color: #009688;
        color: #fff;
        white-space: nowrap;
        text-align: center;
        font-size: 14px;
        border: none;
        border-radius: 2px;
        cursor: pointer;
    }

    .study {
        background-color: #49af4a;
        position: absolute;
        right: 29px;
        top: 95px;
    }

    .class-item-list li {
        font-size: 13px;
        margin-bottom: 8px;
    }

    ol,
    ul {
        list-style: none;
    }

    .class-item-title {
        font-size: 18px;
        font-weight: bold;
        margin-bottom: 21px;
    }

    .class-item-content {
        display: inline-block;
        vertical-align: top;
        padding: 3px 0px;
    }

    img {
        vertical-align: middle;
        border: 0;
        -ms-interpolation-mode: bicubic;
    }

    .class-item-img {
        height: 180px;
        width: 287px;
        margin-right: 40px;
    }

    .class-item {
        height: 232px;
        width: 100%;
        border-radius: 9px;
        padding: 24px 38px;
        color: #333333;
        position: relative;
        margin-bottom: 25px;
        background-color: #fff;
        border: 1px solid #f0f0ee;
    }

    .class-container {
        padding: 15px 0;
        min-height: 600px;
    }

    .font-16 {
        font-size: 16px;
    }

    .md-2018040807-xxw .top-titx {
        padding: 0 !important;
    }

    .md-2018040807-xxw .top-titx {
        line-height: 60px;
        padding: 0 28px;
        border-bottom: 1px solid #ddd;
    }

    .bgcolor-f6f5fa {
        background-color: unset !important;
    }

    .pull-right {
        float: right;
    }

    .bgcolor-f6f5fa {
        background: #f6f5fa;
    }

    .md-2018040807-xxw .right-contx {
        width: 940px;
        min-height: 450px;
        padding-bottom: 34px;
        border-radius: 4px;
    }
</style>


// WEBPACK FOOTER //
// src/components/train/personalCenter/trainPlanCourse.vue